var _style, _text, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 289 77.4",
    style: {
      enableBackground: "new 0 0 289 77.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{font-family:'AdobeSongStd-Light-GBpc-EUC-H';}\r\n\t.st2{font-size:55px;}\r\n\t.st3{fill:#FE9F07;}\r\n")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 109.9 53.59)",
    className: "st0 st1 st2"
  }, "\u7EDD\u5BF9\u6D3E")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.7,34.3c0-1.8,0-3.7,0-5.5c0-0.5,0-1.2,0.6-1.4c0.5-0.2,0.9,0.3,1.2,0.6c2.6,2.2,5.2,4.5,7.9,6.5 c4.4,3.2,10.6,1.3,12.4-3.7c1.2-3.4-0.2-7.2-3.7-8.8c-2.4-1-2.8-2.5-2.8-4.8c0.1-4.6,0.9-5.2,5.2-3.4c5.7,2.3,9.1,6.5,10,12.5 c0.2,1.2,0.5,1.2,1.5,1c9.2-2.4,17.6,4.3,18,12.3c0.1,1.2,0.3,2.4,0.7,3.6c0.8,2.7,2.2,3.8,4.8,3.9c2.6,0,4.2-1.2,5.1-3.7 c0.5-1.4,0.6-2.8,0.6-4.2c0-1.6,0.8-2.3,2.4-2.4c5.8-0.5,6.6,0.3,5.5,6c-0.2,0.8-0.3,1.6-0.5,2.4c-2.8,9.7-13.8,13.1-21.7,6.8 c-0.8-0.7-1.3-0.7-2.2-0.1c-8.4,6.2-19.7,2.3-22.5-7.7c-0.4-1.3-0.7-1.5-2-1c-3.8,1.4-7.7,1.4-11.5-0.1c-1.3-0.5-1.5-0.2-1.8,1 C24.9,54.7,16.4,56.2,9.3,54.3c-4-1.1-6.4-3.9-7.7-7.7C-0.2,41-0.1,35.1,0.2,29.2c0.1-1.4,0.9-2,2.3-2c6.1-0.3,6.2-0.3,6.1,5.7 c-0.1,3.3-0.4,6.6,0.4,9.8c0.7,3,2.4,4.5,5,4.5c2.7,0,4.6-1.5,5.3-4.5C19.9,40,19.8,37.1,19.7,34.3z M56,47.3 c3.6,0,6.6-2.8,6.6-6.4c0-3.7-2.9-6.7-6.6-6.7c-3.6,0-6.6,3-6.6,6.7C49.4,44.4,52.4,47.3,56,47.3L56,47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.2,17.5c0.2,2-0.2,3.8-2.9,4.7c-2,0.7-3.1,2.7-3.5,4.8c-0.3,1.5-1,1.6-2.1,0.8c-3.8-2.4-4.2-4.1-1.9-8 c1.7-2.9,4.1-5.1,7.4-6.2c2.4-0.8,2.9-0.5,3,2.1C31.2,16.2,31.2,16.6,31.2,17.5L31.2,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.6,27.5c0.6,0,1.2,0,1.8,0c0.3,0,0.7,0,1,0.1c2.4,1.4,1.2,3.6,1.3,5.5c0.1,1.3-0.6,2.2-2.1,2.2 c-0.3,0-0.7,0-1,0.1c-5,0.2-5.5-0.3-5.3-5.1C79.5,27.7,79.9,27.5,83.6,27.5L83.6,27.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.974c8ec701b11297bfeccdde5382f851.svg";
export { ForwardRef as ReactComponent };